module.exports = __webpack_public_path__ + "static/media/loc2_img14.ac910e26.jpg";